export default __webpack_public_path__ + "static/media/delivery-truck-1.04aec5cf.png";